export const PlayArrowIconNew = () => {
    return (
        <svg
            width='14'
            height='14'
            viewBox='0 0 14 14'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M13.25 7L0.75 0.75V13.25L13.25 7Z'
                stroke='white'
                stroke-opacity='0.5'
                stroke-width='1.5'
                stroke-linecap='round'
                stroke-linejoin='round'
            />
        </svg>
    );
};
